'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiRadar = function TiRadar(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 33.3c6.4 0 11.7-5.2 11.7-11.6s-5.3-11.7-11.7-11.7c-6.4 0-11.7 5.2-11.7 11.7s5.3 11.6 11.7 11.6z m-1.7-19.8v3.2c0 0.9 0.8 1.6 1.7 1.6s1.7-0.7 1.7-1.6v-3.2c3.2 0.7 5.8 3.2 6.5 6.5h-3.2c-0.9 0-1.7 0.7-1.7 1.7s0.8 1.6 1.7 1.6h3.2c-0.7 3.3-3.3 5.9-6.5 6.5v-3.1c0-1-0.8-1.7-1.7-1.7s-1.7 0.7-1.7 1.7v3.1c-3.2-0.6-5.8-3.2-6.5-6.5h3.2c0.9 0 1.7-0.7 1.7-1.6s-0.8-1.7-1.7-1.7h-3.2c0.7-3.3 3.3-5.8 6.5-6.5z' })
        )
    );
};

exports.default = TiRadar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/radar.js
// module id = 3935
// module chunks = 0